import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import { authApi } from '../lib/api';

interface Props {
  onAuth: () => void | Promise<void>;
}

export default function ResetPasswordPage({ onAuth }: Props) {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (password.length < 8) return setErr('Password must be at least 8 characters');
    if (password !== confirm) return setErr("Passwords don't match");
    setSubmitting(true);
    try {
      await authApi.passwordReset(token, password);
      await onAuth();
      navigate('/', { replace: true });
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Reset failed');
      setSubmitting(false);
    }
  }

  if (!token) {
    return <AuthLayout title="Reset link missing"><p className="text-sm text-red-600">This page needs a token from a reset email.</p></AuthLayout>;
  }

  return (
    <AuthLayout title="Reset your password">
      <form onSubmit={submit} className="space-y-3">
        <div>
          <label className="block text-xs font-semibold text-slate-700 mb-1.5 uppercase tracking-wide">New password</label>
          <input type="password" autoComplete="new-password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} className="input" autoFocus />
        </div>
        <div>
          <label className="block text-xs font-semibold text-slate-700 mb-1.5 uppercase tracking-wide">Confirm password</label>
          <input type="password" autoComplete="new-password" minLength={8} required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input" />
        </div>
        {err && <p className="text-xs text-red-600">{err}</p>}
        <button type="submit" disabled={submitting} className="w-full btn-primary justify-center py-2">
          {submitting ? 'Saving…' : 'Reset password'}
        </button>
      </form>
    </AuthLayout>
  );
}
